import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n/index';
import { Link, useNavigate } from 'react-router-dom';
import FAQ from '../FAQ';
import BeforeAfter from '../BeforeAfter';
import PricingLandingPage from '../PricingLandingPage';
// import Testimonial from '../Testimonial';
// import BeforeAfterTestimonial from '../BeforeAfterTestimonial';
import CookieConsent from '../CookieConsent';
import GiveawayModal from '../GiveAway';
import QuickSignUpEmailAndGoogleContainer from '../../containers/QuickSignUpEmailAndGoogleContainer';
// import LandingPerfectHeadshot from '../LandingPerfectHeadshot';
import PhotoPipeLine from '../PhotoPipeLine';
import TrustProcess from '../TrustProcess';
import TrustStrip from '../landing/TrustStrip';
import Benefits from '../landing/Benefits';
import UseCases from '../landing/UseCases';
import Box from '@mui/material/Box';
import { Grid, Card, CardContent, Typography, Skeleton } from '@mui/material';
import { styled } from '@mui/material/styles';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import FaceRetouchingNaturalIcon from '@mui/icons-material/FaceRetouchingNatural';
import MovieFilterIcon from '@mui/icons-material/MovieFilter';
import OpenIconSpeedDial from '../OpenIconSpeedDial';
import AIPhotographyLanding from '../AIPhotographyLanding';
import Testimonial from '../Testimonial';
import BeforeAfterTestimonial from '../BeforeAfterTestimonial';
import StarIcon from '@mui/icons-material/Star';
import { Button, Container, Stack, Rating } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const StyledCard = styled(({ darkMode, ...props }) => <Card {...props} />)(({ darkMode }) => ({
  backgroundColor: darkMode ? '#1E1E1E' : '#FFFFFF',
  borderRadius: '12px',
  cursor: 'pointer',
  transition: 'transform 0.2s ease-in-out',
  '&:hover': {
    transform: 'translateY(-4px)',
  },
}));

const icons = {
  AIHeadshots: <CenterFocusStrongIcon />,
  AIShorts: <MovieFilterIcon />,
  AIInfluencers: <FaceRetouchingNaturalIcon />,
};

const aiTools = [
  {
    title: 'AI Headshot',
    description: 'Professional AI-powered headshot photos in minutes',
    icon: icons.AIHeadshots,
    color: '#00bcd4',
    callBtnName: 'Explore →',
    link: '/ai-headshot-generator',
    onClick: () => {
    },
  },
  {
    title: 'AI Influencers',
    description: 'Generate unique virtual influencers for your ads, social medias, and more',
    icon: icons.AIInfluencers,
    color: '#4ECDC4',
    callBtnName: 'Explore →',
    link: '/ai-influencers',
    onClick: () => {
    },
  },
  {
    title: 'AI Shorts (Coming Soon)',
    description: 'Transform photos into engaging video content',
    icon: icons.AIShorts,
    color: '#FFD93D',
    callBtnName: 'Join Waitlist →',
    link: '/',
    onClick: () => {
    },
  },
];

const PackSkeleton = ({ darkMode }) => (
  <Card
    sx={{
      backgroundColor: darkMode ? '#1a1a1a' : 'white',
      // border: darkMode ? '1px solid #333' : 'none',
      borderRadius: 2,
      overflow: 'hidden', // Ensure shimmer stays within bounds
      position: 'relative', // For shimmer positioning
      '&::after': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(
          90deg,
          transparent 0%,
          ${darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(255, 255, 255, 0.5)'} 50%,
          transparent 100%
        )`,
        animation: 'shimmer 1.5s infinite',
        transform: 'translateX(-100%)',
      },
      '@keyframes shimmer': {
        '100%': {
          transform: 'translateX(100%)',
        },
      },
    }}
  >
    <Skeleton
      variant="rectangular"
      height={165}
      animation="wave"
      sx={{
        backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)',
        transform: 'scale(1)', // Prevents weird animation artifacts
      }}
    />
    <CardContent>
      <Skeleton
        variant="text"
        width="60%"
        height={24}
        animation="wave"
        sx={{
          backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)',
          transform: 'scale(1)',
          marginBottom: 1,
        }}
      />
      <Skeleton
        variant="text"
        width="90%"
        height={20}
        animation="wave"
        sx={{
          backgroundColor: darkMode ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.06)',
          transform: 'scale(1)',
        }}
      />
    </CardContent>
  </Card>
);

const PackItem = ({ item, onClick, darkMode }) => (
  <Card
    onClick={onClick}
    sx={{
      borderRadius: 2,
      cursor: 'pointer',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'transform 0.2s, box-shadow 0.2s',
      backgroundColor: darkMode ? '#1a1a1a' : 'white',
      // border: darkMode ? '1px solid #333' : 'none', // Added border for dark mode
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: darkMode ? '0 4px 20px rgba(0,0,0,0.5)' : 6, // Custom shadow for dark mode
      },
    }}
  >
    <div>
      <div className="relative aspect-w-16 aspect-h-9">
        <img src={item.image} alt={item.title} className="w-full h-full object-cover" />
        {item.isHot && (
          <div
            className="absolute top-2 right-2 bg-blue-500 text-white text-xs font-bold px-2 py-1 rounded-full"
            style={{ marginTop: '-12px' }}
          >
            Hot
          </div>
        )}
      </div>
      <CardContent>
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          gutterBottom
          fontFamily="inherit"
          sx={{ color: darkMode ? '#ffffff' : '#000000' }}
        >
          {item.title}
        </Typography>
        <Typography
          fontFamily="inherit"
          variant="body1"
          sx={{
            color: darkMode ? '#9ca3af' : '#6b7280',
            fontSize: '12px',
          }}
        >
          {item.description}
        </Typography>
      </CardContent>
    </div>
  </Card>
);

const StyledBadge = styled(Box)(({ theme }) => ({
  background: '#ffffff1a',
  color: '#4aeaff',
  padding: '8px 16px',
  borderRadius: '24px',
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
}));

const CTAButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#01a9bf',
  color: 'white',
  padding: '16px 32px',
  fontSize: '1.125rem',
  borderRadius: '8px',
  textTransform: 'none',
  '&:hover': {
    backgroundColor: '#e65c00',
  },
}));

const ReviewBadge = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

const LandingPage = ({ userData, engine }) => {
  const [currentLanguage, setCurrentLanguage] = useState('');
  const [imageIndex, setImageIndex] = useState(0);
  const [isShowLoginWithGoogle, setIsShowLoginWithGoogle] = useState(false);
  const [isShowLoginWithEmailLink, setIsShowLoginWithEmailLink] = useState(false); // For unsupported browsers
  const [redirectPaymentUrl, setRedirectPaymentUrl] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [darkMode, setDarkMode] = useState(true);
  const [showPhotoPipeLine, setShowPhotoPipeLine] = useState(false);
  const [selectedPhotoPack, setSelectedPhotoPack] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isShowAIPhotoPipeLine, setIsShowAIPhotoPipeLine] = useState(true);

  const urls = [
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F559dfbae7d7d63c8.webp?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fbb64cfb25f7eae50.webp?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F77bf220a922a4137.webp?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F9af6a5ed5b2ea39d.webp?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F4e2757a71f2da5e4.webp?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F5a9e4c24d0bdb6c6.webp?alt=media',
  ];

  const exampleImages = [
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F6ea74a4dc5049d90.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F50ea4a071fcb6615.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe8a661f14c55d16e.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F4df30b3e3ce5188b.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F60a297d735db38b1.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F5c6d7b32fd46e486.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe51710144bd4d210.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe1f4822c8f2069ca.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F11216cae0a27625a.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F3a4a1b5266befc7d.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Ff3d07c433e1cdf97.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F4a00e4738f780258.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fcab453ff05ace915.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F0b066f886c3a43e4.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fb5c698dffbfbbd00.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fcd519f12e3b4e6b0.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F68296782070453fa.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fda2875316fd83963.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F4bf049e60e325948.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F6555a9f1d20ea80d.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F46dea262be9fa5d4.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F660635e63253d4e9.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fd486ae76e71f1917.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F495329578c427233.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F0e9a26dc801859e6.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F9d7e24cc6d61bed5.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Faddd9909f9d52b33.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe3f17bbbaa33358a.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Ff2e05c3193700c54.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F37e210917f7f0508.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F29dc86906d691c6b.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fb7a9182986860c3c.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F9afb856603cd6227.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F37bb5f30a87a371e.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F037ca7ba64cae4ac.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F00c0e7a1c3180250.jpg?alt=media',

    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Ff7f9169989756870.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F353daf78988018a3.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F313011e29baf5a2f.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fbe14d2c799f53900.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F01c956d74712693c.jpg?alt=media',
    'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe3ac97bbddf70867.jpg?alt=media',
    // 'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fab7cb42058a958f8.jpg?alt=media'
  ];

  const trendingPacks = [
    {
      id: 'business_headshots',
      title: 'Professional headshots',
      description: 'Instantly generate polished professional headshots',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F9d5e496ef29037b8.png?alt=media',
      isHot: true,
      category: ['for_business', 'trending'],
      prompt: '',
      createdAt: '2024-09-13T14:03:54.874Z',
      active: true,
      showOnLanding: true,
    },
    {
      id: 'halloween',
      title: '🎄 Christmas photos',
      description: 'Christmas is coming! Transform yourself in Christmas costume',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F51579fe090e90712.webp?alt=media',
      isHot: true,
      category: ['for_creator', 'trending'],
      prompt: '',
      createdAt: '2024-09-25T14:32:37.514Z',
      active: true,
      showOnLanding: true,
    },
    {
      id: 'tech_conference',
      title: 'Tech conference',
      description: 'Take polished professional photos at Conference',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F8906e23b875483d5.png?alt=media',
      isHot: false,
      category: ['trending'],
      prompt: '',
      createdAt: '2024-09-13T14:03:54.874Z',
      active: true,
      showOnLanding: true,
    },
    {
      id: 'travel_photos',
      title: 'Travel photos',
      description: 'Imagine any where you go to travel with AI',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fe724f54bca4f0d4d.png?alt=media',
      isHot: false,
      category: ['trending'],
      prompt: '',
      createdAt: '2024-09-13T14:03:54.874Z',
      active: true,
      showOnLanding: true,
    },
    {
      showOnLanding: true,
      description: 'Instant, professional headshots for real estate agents',
      id: 'realestate_headshots',
      createdAt: '2024-10-14T09:25:23.361Z',
      isHot: false,
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F3a836a3c110d677e.webp?alt=media',
      active: true,
      prompt: '',
      category: ['for_business'],
      title: 'Real estate headshots',
    },
    // {
    //   showOnLanding: true,
    //   title: 'Doctor headshots',
    //   id: 'doctor_headshots',
    //   image:
    //     'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F5922c8e0f75c0db7.webp?alt=media',
    //   isHot: false,
    //   createdAt: '2024-10-14T09:54:13.544Z',
    //   active: true,
    //   prompt: '',
    //   description: 'Professional doctor headshots, ready instantly',
    //   category: ['for_business'],
    // },
    {
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F578d64d841e73ea1.webp?alt=media',
      id: 'cardealership_headshots',
      active: true,
      title: 'Car dealership headshots',
      description: 'Drive Sales with AI-enhanced Car dealership headshots',
      prompt: '',
      showOnLanding: true,
      isHot: false,
      createdAt: '2024-10-14T10:23:55.812Z',
      category: ['for_business'],
    },
    {
      active: true,
      isHot: false,
      id: 'healthcare_headshots',
      description: 'Get professional healthcare headshots instantly',
      title: 'Healthcare headshots',
      category: ['for_business'],
      prompt: '',
      title: 'Healthcare headshots',
      description: 'Get professional healthcare headshots instantly',
      showOnLanding: true,
      createdAt: '2024-10-14T04:30:59.749Z',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2F52e85ebea230a508.webp?alt=media',
    },
    {
      id: 'teacher_headshots',
      isHot: false,
      title: 'Teacher headshots',
      description: 'Get polished teacher headshots instantly',
      showOnLanding: true,
      category: ['for_business'],
      prompt: '',
      image:
        'https://firebasestorage.googleapis.com/v0/b/headshotsnowai-prod.firebasestorage.app/o/marketing%2Fc86e4545560bb3e3.webp?alt=media',
      createdAt: '2024-10-14T08:43:55.148Z',
      active: true,
    },
  ];

  const { t } = useTranslation();
  const changeLanguage = lng => {
    i18n.changeLanguage(lng);
  };

  // const userPreferredLanguage = navigator.language || navigator.userLanguage;

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const refParam = urlSearchParams.get('ref');
    const affParam = urlSearchParams.get('via');

    if (refParam) {
      localStorage.setItem('refCode', refParam);
    } else {
      localStorage.setItem('refCode', '');
    }

    if (affParam) {
      localStorage.setItem('affCode', affParam);
    } else {
      localStorage.setItem('affCode', 'reok');
    }

    const redirect = urlSearchParams.get('r');

    if (redirect) {
      localStorage.setItem('redirect', redirect);
    } else {
      localStorage.setItem('redirect', '');
    }

    setCurrentLanguage(i18n.language);
  }, [i18n.language]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setImageIndex(prevIndex => (prevIndex + 1) % urls.length);
    }, 2000);

    // Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (!isShowLoginWithGoogle && (userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading)))
        setShowModal(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, [isShowLoginWithGoogle, userData]);

  useEffect(() => {
    // Simulate loading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  function showLogin() {
    setIsShowLoginWithGoogle(true);
  }

  function showLoginWithOutPayment() {
    setRedirectPaymentUrl('');

    // const redirect = localStorage.getItem('redirect');
    // if (redirect === "fb") {
    //   setIsShowLoginWithEmailLink(true);
    //   return;
    // }
    setIsShowLoginWithGoogle(true);
  }

  function showLoginForHeadshots() {
    setRedirectPaymentUrl('/app/?pack=ai_headshots&view=start');
    setIsShowLoginWithGoogle(true);
  }

  function onShowLogin(isShow) {
    setIsShowLoginWithGoogle(false);
    setIsShowLoginWithEmailLink(false);
  }

  function showLoginForPayment(redirectUrl) {
    setRedirectPaymentUrl(redirectUrl);

    const redirect = localStorage.getItem('redirect');
    if (redirect === 'fb') {
      setIsShowLoginWithEmailLink(true);
      return;
    }
    setIsShowLoginWithGoogle(true);
  }

  const handleSubmitted = submitted => {
    setIsSubmitted(submitted);
  };

  const openPhotoPipeLine = (e, item) => {
    e.preventDefault();

    if (userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading)) {
      // setSelectedPhotoPack(item);
      // setShowPhotoPipeLine(true);
      setIsShowLoginWithGoogle(true);
    } else {
      window.location.href = `${currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`}/?pack=${item.id}`;
    }
  };

  const closePhotoPipeLine = () => {
    setShowPhotoPipeLine(false);

    if (userData === null || userData === undefined) {
      setIsShowLoginWithGoogle(true);
    }
  };

  const handleSelectCollection = () => {

  }

  const onCloseAIPhotoPipeLine = () => {
    setIsShowAIPhotoPipeLine(false);
  }

  // const onLoginFirst = () =>  {
  //   setTimeout(() => {
  //     setIsShowLoginWithGoogle(true);
  //     setShowPhotoPipeLine(false);
  //   }, 1000);
  // }

  return (
    <div>
      {/* <OpenIconSpeedDial /> */}
      {/* <AIPhotographyLanding
        t={t}
        userData={userData}
        open={isShowAIPhotoPipeLine}
        onClose={onCloseAIPhotoPipeLine}
        darkMode={darkMode}
        handleSelectCollection={handleSelectCollection}
      /> */}
      <main className="bg-black">
        <div
          style={{
            backgroundImage: "url('/images/REOKSTUDIO.webp')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            position: 'relative',
          }}
        >
          <Box
            className="landing-cover-header"
            sx={{
              background: 'linear-gradient(to bottom, rgba(0,0,0,0.6), rgba(0,0,0,0.9))',
              minHeight: '80vh',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Container maxWidth="lg">
              <Stack spacing={4} alignItems="center">
                <StyledBadge>
                  <span>✨</span>
                  <Typography variant="subtitle2" fontWeight="bold">
                    PROFESSIONAL AI HEADSHOTS, DELIVERED ONLINE
                  </Typography>
                </StyledBadge>

                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    variant="h2"
                    component="h1"
                    fontWeight="bold"
                    color="white"
                    gutterBottom
                    sx={{
                      fontSize: { xs: '2.5rem', md: '3.75rem' },
                      lineHeight: 1.2,
                    }}
                  >
                    AI Professional Headshots<br />
                    <Box component="span" sx={{ color: '#49eaff' }}>Delivered Online</Box>
                  </Typography>
                  <Typography
                    variant="h6"
                    color="text.secondary"
                    sx={{
                      maxWidth: '800px',
                      mx: 'auto',
                      color: 'rgba(255,255,255,0.7)'
                    }}
                  >
                    Upload your photos, choose your style, and receive polished professional headshots for LinkedIn,
                    resumes, company bios, and business profiles.
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1.5, color: 'rgba(255,255,255,0.5)' }}
                  >
                    Results are AI-generated — not studio photographs. Quality depends on the photos you upload.
                  </Typography>
                </Box>

                {/* <CTAButton 
                  onClick={showLoginWithOutPayment}
                  endIcon={<ArrowForwardIcon />}
                >
                  Create your headshots now
                </CTAButton> */}
                <div className="upgrade-btn-wrapper">
                  {userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading) ? (
                    <div onClick={showLoginWithOutPayment} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </div>
                  ) : (
                    <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </Link>
                  )}
                </div>

                <Stack
                  direction={{ xs: 'column', sm: 'row' }}
                  spacing={4}
                  alignItems="center"
                  sx={{ mt: 4 }}
                >
                  <div className="customer-demo-wrapper">
                    <div className=" relative mx-auto space-y-4">
                      <div className="flex items-center gap-3">
                        <div className="flex -space-x-3 overflow-hidden">
                          <img
                            src="/images/customer13.webp"
                            alt=""
                            className="inline-block h-10 w-10 rounded-full border-[2px] border-white"
                            width={40}
                            height={40}
                          />{' '}
                          <img
                            style={{ marginLeft: '-12px' }}
                            src="/images/customer16.webp"
                            alt=""
                            className="inline-block h-10 w-10 rounded-full border-[2px] border-white"
                            width={40}
                            height={40}
                          />{' '}
                          <img
                            style={{ marginLeft: '-12px' }}
                            src="/images/customer17.webp"
                            alt=""
                            className="inline-block h-10 w-10 rounded-full border-[2px] border-white"
                            width={40}
                            height={40}
                          />{' '}
                          <img
                            style={{ marginLeft: '-12px' }}
                            src="/images/customer11.webp"
                            alt=""
                            className="inline-block h-10 w-10 rounded-full border-[2px] border-white"
                            width={40}
                            height={40}
                          />{' '}
                          <img
                            style={{ marginLeft: '-12px' }}
                            src="/images/customer19.webp"
                            alt=""
                            className="inline-block h-10 w-10 rounded-full border-[2px] border-white"
                            width={40}
                            height={40}
                          />
                        </div>{' '}
                        <div className="flex" style={{ color: '#facc15' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>{' '}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>{' '}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>{' '}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>{' '}
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="h-5 w-5">
                            <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                          </svg>
                        </div>
                      </div>{' '}
                      <p className="text-sm text-gray-500">{t('landing.loveBy')}</p>
                    </div>
                  </div>
                </Stack>
              </Stack>
            </Container>
          </Box>
        </div>
      </main>
      <main>
        {/* Trust strip: honest proof + industries served */}
        <TrustStrip />
        {/* Before After slider */}
        <section className="bg-black relative overflow-hidden pt-5">
          <BeforeAfterTestimonial />
          {/* <Box
            sx={{
              width: '100%',
              height: 280,
              display: 'flex',
              position: 'relative',
              backgroundColor: '#000',
              overflow: 'hidden',
              willChange: 'transform',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 2,
                animation: 'slideImages 80s linear infinite',
                willChange: 'transform',
                transform: 'translate3d(0, 0, 0)',
                backfaceVisibility: 'hidden',
                '@keyframes slideImages': {
                  '0%': {
                    transform: `translate3d(calc(-280px * ${exampleImages.length}), 0, 0)`,
                  },
                  '100%': {
                    transform: 'translate3d(0, 0, 0)',
                  },
                  '0%': {
                    transform: `translate3d(calc(-280px * ${exampleImages.length}), 0, 0)`,
                  },
                },
                '&:hover': {
                  animationPlayState: 'paused',
                },
              }}
            >
              {[...exampleImages, ...exampleImages, ...exampleImages].map((image, index) => (
                <Box
                  key={index}
                  sx={{
                    position: 'relative',
                    width: '180px',
                    flexShrink: 0,
                  }}
                >
                  <Box
                    component="img"
                    src={image}
                    loading="lazy"
                    decoding="async"
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      willChange: 'transform',
                      transform: 'translate3d(0, 0, 0)',
                      WebkitFontSmoothing: 'antialiased',
                      transition: 'transform 0.3s ease',
                      opacity: 0,
                      borderRadius: '10px',
                      animation: 'fadeIn 0.5s ease forwards',
                      '@keyframes fadeIn': {
                        to: { opacity: 1 }
                      },
                      '&:hover': {
                        transform: 'scale(1.05)',
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>
          </Box> */}
        </section>

        {/* Benefits grid (replaces the old empty "why choose us" text block) */}
        <Benefits />

        <section className="bg-black relative overflow-hidden pb-1">
          <div className={`container ${darkMode ? 'text-white' : 'text-black'}`}>
            <p className={`label-wrapper mb-3 bold coupon-card`}>
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#facc14"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="lucide lucide-flame"
                >
                  <path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z" />
                </svg>
                Trending now
              </span>
            </p>
            <Box sx={{ pt: 1 }}>
              <Grid container spacing={2}>
                {isLoading
                  ? Array.from(new Array(8)).map((_, index) => (
                    <Grid item xs={6} sm={6} md={3} lg={3} key={index}>
                      <PackSkeleton darkMode={darkMode} />
                    </Grid>
                  ))
                  : trendingPacks.map((item, key) => (
                    <Grid item xs={6} sm={6} md={3} lg={3} key={key}>
                      <PackItem item={item} onClick={e => openPhotoPipeLine(e, item)} darkMode={darkMode} />
                    </Grid>
                  ))}
              </Grid>
            </Box>
            <div className="container mx-auto px-4 mt-10">
              <div className="flex flex-col items-center text-center">
                <div className="upgrade-btn-wrapper">
                  {userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading) ? (
                    <div onClick={showLoginWithOutPayment} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </div>
                  ) : (
                    <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* How it works */}
        <section className="bg-black relative overflow-hidden section-top-180">
          <div className="space-y-8 md:space-y-[85px]">
            <div className="container">
              <div className="w-full" id="how-it-works">
                <div className="mx-auto relative z-[10] text-center mx-auto md:text-center mb-3 label-wrapper">
                  <span>4 simple steps</span>
                </div>
                <h2 className="mx-auto relative z-[10] t-50 text-white mb-3 md:mb-6 font-bold text-center mx-auto md:text-center">
                  How it works
                </h2>
              </div>
              <div
                className="mx-auto font-body text-gray-500 relative z-10 t-20-l text-center mx-auto md:text-center mb-6 md:mb-6"
                style={{ maxWidth: '722px' }}
              >
                <p className="text-lg">Get your AI-generated professional headshots in 4 simple steps</p>
              </div>
              {/* How it works steps */}
              <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
                {[1, 2, 3, 4].map((n) => (
                  <div
                    key={n}
                    className="rounded-2xl border border-white/10 bg-white/[0.04] p-6 text-center transition duration-200 hover:-translate-y-1 hover:border-white/20"
                  >
                    <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full border border-brand/30 bg-brand/15 text-xl font-bold text-brand-light">
                      {n}
                    </div>
                    <h3 className="text-base font-semibold text-white">{t(`landing.step${n}`)}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-white/60">{t(`landing.step${n}Sub`)}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="bg-black relative overflow-hidden ">
          <div className="space-y-8 md:space-y-[85px]">
            <div className="container">
              <div className="container rnftg-h-full rnftg-w-full mt-4">
                <div className="rnftg-h-full dark:rnftg-bg-gray-900">
                  <div className="rnftg-flex rnftg-flex-col pd-2">
                    <div className="rnftg-grid rnftg-gap-custom rnftg-grid-flow-row rnftg-grid-cols-3 md:rnftg-grid-cols-3 lg:rnftg-grid-cols-6 xl:rnftg-grid-cols-6">
                      {exampleImages.map((url, index) => (
                        <article
                          key={index}
                          className="rnftg-item rnftg-rounded-2xl dark:rnftg-bg-gray-800 rnftg-shadow-lg hover:rnftg-shadow-xl rnftg-transition rnftg-duration-300"
                        >
                          <div className="rnftg-item__img-wrapper_landing">
                            <div className="landing-result">
                              <img className="banner-video" alt="reok" src={url}></img>
                            </div>
                          </div>
                        </article>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container mx-auto px-4 mt-10 mb-10">
              <div className="flex flex-col items-center text-center">
                <div className="upgrade-btn-wrapper">
                  {userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading) ? (
                    <div onClick={showLoginWithOutPayment} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </div>
                  ) : (
                    <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="upgrade-button">
                      {t('button.try')}
                      <span style={{ marginLeft: '4px' }}>→</span>
                    </Link>
                  )}
                </div>
              </div>
            </div>
        </section>

        {/* Show customers feedback section */}
        <section
          className="relative overflow-hidden bg-black section-top-none section-top-90 section-bottom-90"
        >
          <Testimonial t={t} />
        </section>
        {/* Made-for-your-profession use cases */}
        <UseCases />
        {/* Trust, process & fulfillment transparency */}
        <TrustProcess />
        {/* Pricing section */}
        <section className="bg-neutral-black section-top-90 section-bottom-90">
          <PricingLandingPage
            t={t}
            currentLanguage={currentLanguage}
            userData={userData}
            showLoginForPayment={showLoginForPayment}
            showLoginWithOutPayment={showLoginForHeadshots}
          />
          {/* Guarantee anchored to pricing (matches /refund policy) */}
          <div className="mx-auto mt-10 max-w-2xl px-4">
            <div className="flex flex-col items-center gap-3 rounded-2xl border border-brand/30 bg-brand/5 p-6 text-center sm:flex-row sm:text-left">
              <div className="text-3xl">🛡️</div>
              <div>
                <p className="font-semibold text-white">Usable-headshot guarantee</p>
                <p className="mt-1 text-sm text-white/70">
                  If you don't get at least one usable professional headshot, contact us within 14 days for a refund
                  (when no final images have been downloaded).{' '}
                  <Link to={currentLanguage === 'en' ? '/refund' : `/${currentLanguage}/refund`} className="text-brand-light underline">
                    See refund policy
                  </Link>.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* FAQ section */}
        <section className="bg-neutral-black section-bottom-90">
          <div className="relative bg-neutral-black mb-4">
            <div className="container">
              <FAQ t={t} />
            </div>
          </div>
        </section>
        <section
          className="bg-[#101014] bg-blend-luminosity bg-no-repeat bg-center bg-cover h-[50vh] flex items-center justify-center"
          style={{
            backgroundImage: "linear-gradient(360deg, rgb(13, 13, 13) 0%, rgba(16, 16, 20, 30%) 100%), url('/images/footer-cover.png')",
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        >
          <div className="container mx-auto px-4 call-to-action">
            <div className="flex flex-col items-center text-center">
              <h2
                className="mx-auto relative z-[10] text-white t-50 text-neutral-black mb-6 md:mb-6 font-bold text-center mx-auto md:text-center"
                style={{ maxWidth: '722px' }}
              >
                {t('landing.joinNow')}
              </h2>
              <div className="getstarted-btn-wrapper">
                {userData === null || userData === undefined || (userData.loading !== undefined && !userData.loading) ? (
                  <div onClick={showLoginWithOutPayment} className="upgrade-button">
                    {t('button.try')}
                    <span style={{ marginLeft: '4px' }}>→</span>
                  </div>
                ) : (
                  <Link to={currentLanguage === 'en' ? '/app' : `/${currentLanguage}/app`} className="upgrade-button">
                    {t('button.try')}
                    <span style={{ marginLeft: '4px' }}>→</span>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
      {isShowLoginWithGoogle && (
        <QuickSignUpEmailAndGoogleContainer
          onShowLogin={onShowLogin}
          redirectPaymentUrl={redirectPaymentUrl}
          isSubmitted={isSubmitted}
          onSubmitted={handleSubmitted}
        />
      )}
      {/* {isShowLoginWithGoogle && <QuickSignUpLandingPageContainer onShowLogin={onShowLogin} redirectPaymentUrl={redirectPaymentUrl} />} */}
      <CookieConsent />
      {/* <GiveawayModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        isSubmitted={isSubmitted}
        onSubmitted={handleSubmitted}
        currentLanguage={currentLanguage}
        t={t}
      /> */}
      {showPhotoPipeLine && (
        <PhotoPipeLine
          onClose={closePhotoPipeLine}
          firebase={engine}
          darkMode={darkMode}
          userData={userData}
          t={t}
          photoPack={selectedPhotoPack}
        />
      )}
    </div>
  );
};

export default LandingPage;
